/** Há seleção feita e ainda não salva na Matriz de Acessos? Nesse caso a saída pede confirmação para não perder o trabalho. */
export const temSelecaoNaoSalva = (usuariosSelecionados: number[], empresasEfetivas: number[]): boolean =>
  usuariosSelecionados.length > 0 || empresasEfetivas.length > 0;

export interface DestinoSaida {
  path: string;
  state?: { goToEtapa: number };
  /** true = volta à tela anterior (aberta pelo menu, não pelo assistente). */
  voltar: boolean;
}

/** Concluído: vindo do assistente de onboarding volta a ele, na mesma etapa; aberta pelo menu, volta à tela anterior. */
export const destinoAoConcluir = (state?: { fromOnboarding?: boolean; etapa?: number } | null): DestinoSaida =>
  state?.fromOnboarding
    ? { path: '/workflow-aprovacao/onboarding', state: { goToEtapa: state.etapa ?? 1 }, voltar: false }
    : { path: '', voltar: true };
